
import { ModelBase } from "@models/UpsertableBase";
import { SpellLimitation } from "@dndModels/misc/Limitation";
import { DataType } from "@dndModels/Types";

/**
 * 
 */
export class SpellList extends ModelBase {
  data_type: DataType = "spell_list";
  limit: SpellLimitation = new SpellLimitation();

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.limit = obj.limit ? new SpellLimitation(obj.limit) : new SpellLimitation();
      if (!obj.limit && obj.spell_ids) {
        this.limit.spell_ids = obj.spell_ids;
      }
    }
    this.loaded = true;
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      limit: this.limit.toDBObj()
    };
  }

  toLight(): any {
    return this.toDBObj();
  }

  copy(copyMe: SpellList, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.limit = copyMe.limit.clone();
  }

  clone(drop_ids = false): SpellList {
    const new_obj = new SpellList();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}